'use client';

import React, { createContext, PropsWithChildren, useContext } from 'react';
import { CallFormInstance } from './interfaces';

export interface ICallFormContext {
  instance: CallFormInstance,
  isDmPortal: boolean,
  isEvercall: boolean,
}

export const CallFormContext = createContext<ICallFormContext>(null);

export const useCallFormContext = (): ICallFormContext => {
  const context = useContext<ICallFormContext>(CallFormContext);
  if (!context) {
    throw new Error('useCallFormContext must be used within a CallFormProvider');
  }
  return context;
};

interface IProps {
  instance: CallFormInstance,
}

function CallFormContextProvider({ instance, children }: PropsWithChildren<IProps>) {
  const isDmPortal = instance === CallFormInstance.CallSettingsForm;
  const isEvercall = instance === CallFormInstance.ScheduleYourCall;

  return (
    <CallFormContext.Provider value={ { instance, isDmPortal, isEvercall } }>
      { children }
    </CallFormContext.Provider>
  );
}

export default CallFormContextProvider;
